import { AuctionStatus, VehicleStatus } from '../../api-client/enums'

const TYPES = {
  Sold: 1,
  ReserveNotMet: 2,
  Paused: 3,
  ListingExpired: 4,
}

export default function AuctionStatusBadge({ status, reserveIsMet, ...rest }) {
  let type = null

  switch (status) {
    case AuctionStatus.Ended: {
      type = reserveIsMet ? TYPES.Sold : TYPES.ReserveNotMet
      break
    }
    case VehicleStatus.CompletedFromBuyNow: {
      type = reserveIsMet ? TYPES.Sold : TYPES.ListingExpired
      break
    }
    default:
      type = TYPES.Paused
      break
  }

  return (
    <div {...rest}>
      <span>
        {type === TYPES.Sold
          ? 'SOLD'
          : type === TYPES.ReserveNotMet
          ? 'RESERVE NOT MET'
          : type === TYPES.Paused
          ? 'PAUSED'
          : type === TYPES.ListingExpired
          ? 'LISTING EXPIRED'
          : null}
      </span>

      <style jsx>{`
        div {
          width: 19.1rem;
          height: 19.1rem;
          border-radius: 1rem 0 0 0;
          clip-path: polygon(0 0, 0% 100%, 100% 0);

          span {
            position: absolute;
            max-width: 13rem;
            text-align: center;
            color: #fff;
            font-weight: 700;
          }
        }
      `}</style>

      <style jsx>{`
        div {
          background: ${type === TYPES.Sold ? 'var(--primary-color)' : 'var(--alert-color)'};

          span {
            font-size: ${type === TYPES.Sold ? '4rem' : type === TYPES.Paused ? '3rem' : '2.4rem'};
            transform: rotate(-45deg)
              ${type === TYPES.Sold
                ? 'translate(-2rem, 3rem)'
                : type === TYPES.ReserveNotMet || type === TYPES.ListingExpired
                ? 'translate(-2rem, 2.5rem)'
                : 'translate(-2.5rem, 4rem)'};
          }
        }

        @media (max-width: 1024px) {
          div {
            border-radius: 0;
            transform: scale(0.5);
            transform-origin: top left;
          }
        }
      `}</style>
    </div>
  )
}
